module.exports = "<section userAgentCss fxLayout=\"row\" fxLayoutAlign=\"center strech\" fxFlex>\n  <div class=\"page-container\">\n    <router-outlet></router-outlet>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1